import CheckCircleSVG from "@design-system/ui-icons/vanilla/CheckCircle"
import { createIcon } from "../createIcon"

export const CheckCircleIcon = createIcon(CheckCircleSVG)
